// +----------------------------------------------------------------------
// | CNXRC [ CNXRC赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.cnxrc.net All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CNXRC并不是自由软件，未经许可不能去掉CNXRC相关版权
// +----------------------------------------------------------------------
// | Author: CNXRC Team <admin@cnxrc.net>
// +----------------------------------------------------------------------

/**
 * $prompt一行内容input提交封装
 * @param inputType input type 类型
 * @param title 标题
 * @param val 回显的值
 * @returns {Promise<any>}
 */
export default function modalPrompt(inputType, title, val) {
  var _this = this;
  return new Promise(function (resolve, reject) {
    _this.$prompt('', "".concat(title), {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      inputErrorMessage: "\u8BF7\u8F93\u5165".concat(title),
      inputType: inputType,
      inputValue: val ? val : '',
      showClose: true,
      closeOnClickModal: false,
      customClass: 'prompt-form',
      inputPlaceholder: "\u8BF7\u8F93\u5165".concat(title),
      inputValidator: function inputValidator(value) {
        if (value === null) {
          return true;
        }
        if (!value) return '输入不能为空';
        if (value.indexOf(' ') !== -1) return '输入不能为空';
        if (value.length > 50) return '输入限制50字以内';
      },
      beforeClose: function beforeClose(action, instance, done) {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          setTimeout(function () {
            done();
            instance.confirmButtonLoading = false;
          }, 200);
        } else {
          done();
        }
      }
    }).then(function (_ref) {
      var value = _ref.value;
      resolve(value);
    }).catch(function () {
      _this.$message.info('取消输入');
    });
  });
}